<template>
    <div>

        <!--导航栏 start-->
        <van-nav-bar
                title="交易流水"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        >
            <!--通过插槽自定义导航栏右侧的内容 start-->
            <!--            <template #right>-->
            <!--                <van-icon name="search" size="20" @click="onClickRight"/>-->
            <!--            </template>-->
        </van-nav-bar>
        <!--通过插槽自定义导航栏右侧的内容 end-->
        <!--导航栏  end-->
        <!-- 下拉列表选择-->
        <div  style="margin-top:1.2rem; ">
            <van-grid :column-num="1">
                <van-dropdown-menu style="width: 100%; ">
                    <van-dropdown-item  ref="items" :title="merchant_id==''?'全部商户':merchant_name">
                        <div style="height: 13rem;overflow-y: scroll">
                            <van-cell @click="pagexmer()"  title="全部商户" is-link/>
                            <div  v-for="(bububu,index) in option2" :key="index">
                                <van-cell @click="outletmer(bububu.value,bububu.label)" :title="bububu.label" is-link/>
                            </div>
                        </div>
                    </van-dropdown-item>
                </van-dropdown-menu>
            </van-grid>

            <div  class="van-menu">
                <!--门店选择-->
                <van-dropdown-menu class="dropdown-menu">
                    <van-dropdown-item  ref="item" :title="store_id==''?'全部门店':store_name" style="overflow-y:auto;">
                        <van-cell @click="pagex()"  title="全部门店" is-link/>
                        <div v-for="(bububu,index) in option1" :key="index">
                            <van-cell @click="outlet(bububu.value,bububu.label)" :title="bububu.label" is-link/>
                        </div>
                    </van-dropdown-item>
                </van-dropdown-menu>

                <!--时间选择-->
                <!-- 起始时间 -->
                <div class="van-menu-item">
                    <div class="starting">
                        <van-field @click="showPopFn()" v-model="timeValue" :placeholder=systemTime readonly />
                    </div>
                    <van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
                        <van-datetime-picker
                                v-model="currentDate"
                                type="date"
                                title="选择日期"
                                @change="changeFn()"
                                @confirm="confirmFn()"
                                @cancel="cancelFn()"
                        />
                    </van-popup>
                    <!-- 横线 -->
                    <div class="div-hr"><hr></div>

                    <!-- 结束时间 -->
                    <div class="starting">
                        <van-field @click="showPopFn1()" v-model="timeValue1" :placeholder=systemTime readonly />
                    </div>
                    <van-popup v-model="show1" position="bottom" :style="{ height: '40%' }">
                        <van-datetime-picker
                                v-model="currentDate1"
                                type="date"
                                title="选择日期"
                                @change="changeFn1()"
                                @confirm="confirmFn1()"
                                @cancel="cancelFn1()"
                        />
                    </van-popup>
                </div>


            </div>


        </div>



        <!--内容 start-->
        <div style="margin-top:0.02rem">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
<!---->
                <div v-for="(admin,index) in list" :key="index">
                    <van-cell  @click="to_transaction_details(admin.pay_id)">
                        <van-row gutter="20">
                            <van-col span="13">
                                <van-row gutter="20">

                                    <van-col span="24" class="title_font">{{admin.trans_subject}}</van-col>
                                    <van-col span="24" class="date_font">{{admin.trans_oktime}}</van-col>
                                </van-row>
                            </van-col>
                            <van-col span="7">
                                <van-row gutter="20">
                                      <van-col span="24" class="title_font">{{admin.trans_type=="wxpay"?"微信":admin.trans_type=="alipay"?"支付宝":admin.trans_type=="pos_credit"?"POS贷记卡":(admin.trans_type="pos_dedit"?"POS借记卡":"云闪付")}}</van-col>
<!--                                     
                                    <van-col span="24" class="title_font">{{admin.trans_type=="wxpay"?"微信":(admin.trans_type=="alipay"?"支付宝":"云闪付")}}</van-col> -->
                                    <van-col span="24" class="title_font">{{admin.total_fee}}元</van-col>

                                </van-row>
                            </van-col>
                            <van-col span="4"  :class="admin.trans_status==0?'green_likes':(admin.trans_status==1?'green_font':(admin.trans_status==2?'green_likess':'green_like'))" >{{admin.trans_status==0?"待支付":(admin.trans_status==1?'成功':(admin.trans_status==2?'撤销':'退款'))}}</van-col>
                        </van-row>
                    </van-cell>

                </div>


            </van-list>
        </div>
        <!--内容 end-->


    </div>
</template>

<script>

    export default {
        name: "AgentMerchantFlow", //交易流水
        data() {
            return {

                list: [],
                loading: false,
                finished: false,
                //下拉选择
                value1: 0,
                option1: [],
                option2:[],
                //时间选择
                msg: '',
                currentDate: new Date(),
                currentDate1: new Date(),
                changeDate: new Date(),
                show: false, // 用来显示弹出层
                show1: false, // 用来显示弹出层
                timeValue: '',
                timeValue1:"",
                //初始化获取当前时间
                systemTime:"",
                page:0,
                num:10,
                // 门店id
                store_id:'',
                merchant_id:'',
                store_name:'',
                merchant_name:""
            };
        },
        mounted() {
            this.timeFormat(new Date());
            //初始化获取当前的时间
            this.addDate();
            //商户列表信息
            this.theMerchants()
        },
        methods: {
            //选择某个门店
            outlet(a,b){
                this.store_id=a;
                this.store_name=b;
                this.$refs.item.toggle();
                this.page=0;
                this.list=[]
                this.onLoad()
            },
            //选择某个商户
            outletmer(a,b){
                this.merchant_id=a;
                this.merchant_name=b;
                this.$refs.items.toggle();
                this.theStores()
                this.store_id='';
                this.page=0;
                this.list=[]
                this.onLoad()
            },

            // 点击下拉菜单 选择全部门店
            pagex(){
                this.store_id="";
                this.page=0;
                this.list=[];
                //控制下拉菜单收起
                this.$refs.item.toggle();
                this.onLoad()
            },
            // 点击下拉菜单 选择全部商户
            pagexmer(){
                this.merchant_id="";
                this.store_id='';
                this.option1=[];
                this.page=0;
                this.list=[];
                //控制下拉菜单收起
                this.$refs.items.toggle();
                this.onLoad()
            },

            //获取全部的商户
            theMerchants(){
                this.$http.get('/wechat/api.agent.pay/merchants').then(response => {
                    this.option2=response.data.data

                })
            },

            //全部门店列表
            theStores(){
                this.$http.get('/wechat/api.agent.pay/stores', {
                    params: {
                        merchant_id:this.merchant_id
                    }
                }).then(response => {
                    console.log(response.data.data);
                    this.option1=response.data.data

                })
            },
            // 页面初始化的时候确定当前的日期
            addDate() {
                let nowDate = new Date()
                let date = {
                    year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate()
                }
                if(this.$store.state.time!="" &&this.$store.state.time1=="") {
                    this.timeValue=this.$store.state.time
                    this.timeValue1 = date.year + '-' + date.month + '-' + date.date
                }else if (this.$store.state.time=="" &&this.$store.state.time1!="") {
                    this.timeValue= date.year + '-' + date.month + '-' + date.date
                    this.timeValue1=this.$store.state.time1
                }else if (this.$store.state.time!="" &&this.$store.state.time1!="") {
                    this.timeValue=this.$store.state.time
                    this.timeValue1=this.$store.state.time1
                }else if (this.$store.state.time=="" &&this.$store.state.time1=="") {
                    this.timeValue = date.year + '-' + date.month + '-' + date.date,
                        this.timeValue1 = date.year + '-' + date.month + '-' + date.date
                }

            },


            // 时间选择
            showPopFn() {
                this.show = true;
            },
            showPopFn1() {
                this.show1 = true;
            },
            showPopup() {
                this.show = true;
            },
            showPopup1() {
                this.show = true;
            },
            changeFn() { // 值变化是触发
                this.changeDate = this.currentDate // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
            },
            changeFn1() { // 值变化是触发
                this.changeDate = this.currentDate1 // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
            },
            confirmFn() { // 确定按钮
                this.timeValue = this.timeFormat(this.currentDate);
                this.$store.commit("timer",this.timeValue)
                this.show = false;
                this.page=0;
                this.list=[]
                this.onLoad()
            },
            confirmFn1() { // 确定按钮
                this.timeValue1 = this.timeFormat(this.currentDate1);
                this.$store.commit("timer1",this.timeValue1)
                this.show1 = false;
                this.page=0;
                this.list=[]
                this.onLoad()

            },
            cancelFn(){
                this.show = false;
            },
            cancelFn1(){
                this.show1 = false;
            },
            timeFormat(time) { // 时间格式化 2019-09-08
                let year = time.getFullYear();
                let month = time.getMonth() + 1;
                let day = time.getDate();
                return year + '-' + month + '-' + day + ''
            },

            // 左侧返回
            onClickLeft() {
                this.$router.push("/AgentHomepage");
            },
            // 右侧icon跳转至订单查询
            // onClickRight() {
            //     // 跳转至订单查询
            //     this.$router.push('/TransactionSearch');
            // },
            // 列表
            onLoad() {
                // 异步更新数据
                this.page+=1;
                // if (this.store_id!=null) {
                //     this.tive1()
                // }else{
                    this.tive()
                // }
            },
            //根据选择发送请求
            tive(){
                var that=this
                this.$http.get('/wechat/api.agent.pay/listOrder', {
                    params: {
                        merchant_id:that.merchant_id,
                        beginTime:that.timeValue,
                        store_id:that. store_id,
                        endTime:that.timeValue1,
                        pageSize:that.num,
                        pageNum:that.page
                    }
                }).then(response => {
                    console.log("1");
                    that.loading=false;
                    // console.log(response.data.rows[0])
                    if (response.data.rows.length) {
                        that.list.push(...response.data.rows);
                        that.finished = false;
                    }
                    if (response.data.rows.length < that.num)
                    {
                        that.finished = true;
                    }

                })
            },
            //根据选择日期去发送请求
            // tive(){
            //     var that=this
            //     this.$http.get('/wechat/api.order/get_order', {
            //         params: {
            //             merchant_id:this.merchant_id,
            //             start_date:this.timeValue,
            //             end_date:this.timeValue1,
            //             page:this.page,
            //             num:this.num
            //         }
            //     }).then(response => {
            //         console.log("1");
            //         that.loading=false;
            //         if (response.data.data.length) {
            //             that.list.push(...response.data.data);
            //             that.finished = false;
            //         } else{
            //             that.finished = true;
            //         }
            //
            //     })
            // },
            // 跳转至单笔订单明细
            to_transaction_details(pay_id) {
                console.log(pay_id);
                this.$router.push({path:'/AgentTransactionDetails',query:{jobId:pay_id}})

            },
        },
    }
</script>

<style scoped>
    .title_font {
        color: #535353;

    }
    .title_font1 {
        color: #535353;
        position: relative;
        top: 0.33rem;

    }
    .date_font {
        color: #919191;
    }

    .green_font {
        color: #4cd964;
        line-height: 48px;
    }
    .green_like {
        color: red;
        line-height: 48px;
    }
    .green_likes {
        color: darkorange;
        line-height: 48px;
    }
    .green_likess {
        color: #00aaee;
        line-height: 48px;
    }
    .van-menu{
        display: flex;
        justify-content: space-between;
    }
    .van-menu-item{
        width: 64%;
        display: flex;

    }
    .div-hr{
        background-color: white;
        height: 1.27rem;
    }
    hr{
        margin-top: 0.65rem;
        width: 0.4rem;
        background-color: white;
    }
    .dropdown-menu{
        width: 43%;

    }
    .dropdown-menus{
        width: 100%;
    }


</style>
<style scoped="scoped">

    .van-field__control{
        position: relative;
        top: 0.1rem;

    }
    .starting{
        width: 53%;
        background-color: white;

    }
    .van-popup{
        overflow-y: hidden!important;
    }
    .van-dropdown-menu__title::after{
        /* border: none!important; */
    }


</style>
